import type { CrewInsertSchema } from "@adva/types";
import { type EntityFieldConfig } from "@/components/v2/entity-form-config";

export type CrewFormValues = (typeof CrewInsertSchema)["_output"];

export const CREW_FIELDS: EntityFieldConfig<CrewFormValues>[] = [
  { name: "name", label: "Name", control: "text", required: true },
  { name: "status", label: "Status", control: "text" },
  {
    name: "home_base_location",
    label: "Home base location",
    control: "text",
  },
  { name: "worker_count", label: "Worker count", control: "number" },
  {
    name: "started_on",
    label: "Started on",
    control: "text",
    placeholder: "YYYY-MM-DD",
  },
  { name: "notes", label: "Notes", control: "textarea" },
];

export function crewToFormValues(
  c: Record<string, unknown> | undefined,
): Partial<CrewFormValues> {
  if (!c) return {};
  const str = (v: unknown): string | undefined =>
    typeof v === "string" && v.length > 0 ? v : undefined;
  return {
    name: str(c.name) ?? "",
    status: str(c.status),
    home_base_location: str(c.home_base_location),
    worker_count:
      typeof c.worker_count === "number" ? c.worker_count : undefined,
    started_on: str(c.started_on),
    notes: str(c.notes),
  };
}
